module.exports = __webpack_public_path__ + "img/zbj.19b9c542.png";